import React, { Component } from "react";
import { Button,Container,Row,Col,Form } from 'react-bootstrap'
import "./login.css";

import { 
  BrowserRouter as Router, 
  Route, 
  Switch,
  withRouter
} from "react-router-dom";

import { render } from "@testing-library/react";

class SignInPage extends Component {

  constructor(props) {
    super(props);
    this.state = { 
      step: 1,
    }
  }

  componentDidMount() {

  }

  render() {
    const { step } = this.state
    
    return (
        <div>
          <Container>
            <Row>
              <Col xs={12} style={{textAlign:'center'}}>
                <img style={{width:'250px', objectFit: 'contain'}} src={"/img/profile-id.png"} />
              </Col>
              <Col xs={12} md={{span:6,offset:3}} lg={{span:4,offset:4}} style={{marginTop:'35px'}}>
                {/*<h5 style={{fontSize:'.9rem',textAlign:'center',marginBottom:'30px'}}>POR FAVOR INGRESA TU CLAVE DE AGENTE PARA RECUPERAR TU CONTRASEÑA</h5>*/}
                <h5 style={{fontSize:'.9rem',textAlign:'center',marginBottom:'30px'}}>PARA CREAR TU CONTRASEÑA, POR SEGURIDAD ES NECESARIO QUE VALIDES TUS DATOS</h5>

                { step === 1 ?
                  <div>  
                    <Form.Group controlId="formLogin">
                      <Form.Label style={{color:'#259DB4',fontWeight:'500'}}>Ingresa tu tarjeta.id o tu correo electrónico con el que te registraste</Form.Label>
                      <Form.Control onChange={() => {  }} type="text" placeholder="Ejemplo: mb" className="input__login"/>
                    </Form.Group>
                    <Form.Group>
                      <div style={{textAlign:'right'}}>
                        <a href="/signin" className="link__login">Regresar</a>
                      </div>
                    </Form.Group>
                    <Form.Group>
                      <Button block className="btn__login" id="btnConfirmarClave" onClick={() => { alert('Confirmar Clave') }}>Confirmar Clave</Button>
                    </Form.Group>
                  </div>
                  : null
                }
                { step === 2 ?
                  <div>
                    <Form.Group controlId="formLogin">
                      <Form.Label style={{color:'#606060',fontWeight:'300'}}>Paso 2: Registra una contraseña</Form.Label>
                      <Form.Label style={{color:'#606060',fontWeight:'300'}}>Confirma el correo electrónico</Form.Label>
                      <Form.Control type="text" placeholder="correo@wsoft.com.mx" id="correo" className="input__login"/>
                    </Form.Group>
                    <Form.Group controlId="formLogin">
                      <Form.Label style={{color:'#606060',fontWeight:'300'}}>Nueva contraseña</Form.Label>
                      <Form.Control type="text" placeholder="Ingresa una contraseña mayor a 6 digitos" id="password" className="input__login"/>
                    </Form.Group>
                    <Form.Group controlId="formLogin">
                      <Form.Label style={{color:'#606060',fontWeight:'300'}}>Confirmar nueva contraseña</Form.Label>
                      <Form.Control type="text" placeholder="Ingresa una contraseña mayor a 6 digitos" id="confirmPassword" className="input__login"/>
                    </Form.Group>
                    <Form.Group>
                      <Button block className="btn__login" id="btnConcluir" onClick={() => { this.onValidateStep1() }}>Concluir Registro</Button>
                    </Form.Group>
                    <Form.Group>
                      <div style={{textAlign:'right'}}>
                        <a href="/signin" className="link__login">Regresar</a>
                      </div>
                    </Form.Group>
                  </div>
                  : null
                }
              </Col>
              <Col xs={12} style={{textAlign:'center'}}>
                <img style={{width:'130px',height:'86px'}} src={"/img/wsoft.png"} />
              </Col>
            </Row>
          </Container>
        </div>
    );
  }
  
  onValidateStep1() {
    const data = {
      step: 1,
      user: this.state.user
    }
    fetch("https://tarjeta.id/REST/controllers/ControllerAccess.php?opt=validateInfoIDMember", this.headersPOST({...data}))
    .then(response => response.json())
    .then((response) => {
      console.log(response)
    }).catch((error) => console.info(error));
  }

  initState(param) {
    this.props.initsetState(param)
    return true
  }

  initsetState(param) {
    this.props.initsetState(param)
    return true
  }

  headersPOST(data) {
    return {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data),
    }
  }


};

export default withRouter(SignInPage)